var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 139.9 44",
    style: {
      enableBackground: "new 0 0 139.9 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#4285F4;}\n\t.st1{fill:#EA4335;}\n\t.st2{fill:#FBBC05;}\n\t.st3{fill:#34A853;}\n ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,15.7v4.7h11.3c-0.3,2.6-1.2,4.6-2.6,5.9c-1.6,1.6-4.2,3.4-8.7,3.4c-6.9,0-12.3-5.6-12.3-12.5 S10.5,4.7,17.5,4.7c3.7,0,6.5,1.5,8.5,3.4l3.3-3.3C26.5,2.1,22.7,0,17.5,0C8,0,0,7.7,0,17.2s8,17.2,17.5,17.2c5.1,0,9-1.7,12-4.8 c3.1-3.1,4.1-7.5,4.1-11c0-1.1-0.1-2.1-0.2-2.9H17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.6,11.8c-6.1,0-11.2,4.7-11.2,11.1c0,6.4,5,11.1,11.2,11.1S58.8,29.4,58.8,23 C58.8,16.5,53.8,11.8,47.6,11.8z M47.6,29.7c-3.4,0-6.3-2.8-6.3-6.7c0-4,2.9-6.7,6.3-6.7c3.4,0,6.3,2.7,6.3,6.7 C53.9,26.9,51,29.7,47.6,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.3,14.3h-0.2c-1.1-1.3-3.2-2.5-5.9-2.5c-5.6,0-10.4,4.8-10.4,11.1c0,6.2,4.8,11.1,10.4,11.1 c2.7,0,4.8-1.2,5.9-2.5h0.2v1.6c0,4.2-2.3,6.5-5.9,6.5c-3,0-4.8-2.1-5.6-4l-4.2,1.8c1.2,2.9,4.5,6.6,9.9,6.6 c5.7,0,10.6-3.4,10.6-11.6v-20h-4.6V14.3z M96.7,29.7c-3.4,0-5.9-2.9-5.9-6.7c0-3.9,2.6-6.7,5.9-6.7c3.3,0,5.9,2.9,5.9,6.8 C102.7,26.9,100.1,29.7,96.7,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.5,11.8c-6.1,0-11.2,4.7-11.2,11.1c0,6.4,5,11.1,11.2,11.1S83.7,29.4,83.7,23 C83.7,16.5,78.7,11.8,72.5,11.8z M72.5,29.7c-3.4,0-6.3-2.8-6.3-6.7c0-4,2.9-6.7,6.3-6.7s6.3,2.7,6.3,6.7 C78.8,26.9,75.9,29.7,72.5,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.8,0.5h4.8v33.6h-4.8V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,29.7c-2.5,0-4.2-1.1-5.4-3.4l14.9-6.1l-0.5-1.3c-0.9-2.5-3.8-7.1-9.5-7.1c-5.7,0-10.5,4.5-10.5,11.1 c0,6.2,4.7,11.1,11,11.1c5.1,0,8-3.1,9.3-4.9l-3.8-2.5C134.6,28.5,132.9,29.7,130.4,29.7L130.4,29.7z M130.1,16c2,0,3.7,1,4.2,2.4 l-10,4.2C124.2,18,127.6,16,130.1,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google_logo.0468d4e97bae61c550bb66e18a38aad8.svg";
export { ForwardRef as ReactComponent };